import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getGuideCategories(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/category/get`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addGuideCategory(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/category/add`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        updateGuideCategory(ctx, queryParams){
            const id = queryParams.data.id
            
            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/category/update/${id}`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteGuideCategory(ctx, id){
            return new Promise((resolve, reject) => {
            axios
                .delete(`/guide/v1/category/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getGuides(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/get`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addGuide(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/add`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateGuide(ctx, queryParams){
            const id = queryParams.id
            const data = queryParams
            
            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/update/${id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteGuide(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/guide/v1/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getGuideBanners(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post('/guide/v1/banner/get', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addGuideBanner(ctx, queryParams){
            const id  = queryParams.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/guide/v1/banner/add/${id}`, queryParams.formData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post('/guide/v1/banner/updateOrdering', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deteleGuideBanner(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/guide/v1/banner/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateBlockOrdering(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post('/guide/v1/block/updateOrdering', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateGuidesOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/guide/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateCategoryOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/guide/v1/category/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}